import React, { useState, useEffect } from 'react';
import { downloaddbPdf, getCustomerDetailAgentId } from '../services/api';
import '../css/FileDownload.css';

function FileDownload() {
    const [agentId, setAgentId] = useState('');
    const [language, setLanguage] = useState('en');
    const [formLanguage, setFormLanguage] = useState('');
    const [fundType, setFundType] = useState('mutual');
    const [downloadProgress, setDownloadProgress] = useState(0);
    const [loading, setLoading] = useState(false);
    const [reportType, setReportType] = useState('');
    const [customers, setCustomers] = useState([]);
    const [selectedCustomerId, setSelectedCustomerId] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [error, setError] = useState('');
    console.log("Initial reportType:", reportType);


// Fixed: Handle null/undefined customer names
const filteredCustomers = React.useMemo(() => {
    return customers.filter(customer => {
        const name = customer.name || '';  // Fallback to empty string
        return name.toLowerCase().includes(searchQuery.toLowerCase());
    });
}, [customers, searchQuery]);
    const reportTypeOptions = [
        '',
        'Financial Horoscope',
        'Term Insurance Requirement Analysis',
        'Health Insurance Requirement Analysis',
        'Children’s Higher Education Planning',
        'Children’s Wedding Planning'
    ];

    useEffect(() => {
        const storedAgentId = localStorage.getItem("agentId");
        
        if (storedAgentId) {
            setAgentId(storedAgentId);
            console.log("useEffect - fetching with initial reportType:", reportType);
            fetchCustomers(storedAgentId, reportType)
                .then(data => setCustomers(data))
                .catch(error => console.error("Error fetching customers:", error));
        } else {
            setError("Agent ID not found in local storage. Please log in.");
        }
        console.log("🔁 formLanguage updated:", formLanguage);
    }, [formLanguage, reportType]);

    useEffect(() => {
        console.log("Language state updated to:", language);
    }, [language]);

    useEffect(() => {
        // Reset search when report type changes
        setSearchQuery('');
    }, [reportType]);

    const fetchCustomers = async (currentAgentId, currentReportType) => {
        try {
            if (!currentAgentId) {
                console.error("Agent ID is missing.");
                return [];
            }
            console.log("Fetching customers for Agent ID:", currentAgentId, "and Report Type:", currentReportType);
            const response = await getCustomerDetailAgentId(currentAgentId, currentReportType);
            console.log("API Response:", response.data);
            if (response.data && Array.isArray(response.data)) {
                return response.data;
            } else {
                console.error("Invalid customer data received from API.");
                return [];
            }
        } catch (error) {
            console.error("Error fetching customers:", error);
            return [];
        }
    };

    const handleReportTypeChange = (e) => {
        const newReportType = e.target.value;
        console.log("handleReportTypeChange - newReportType:", newReportType);

        setReportType(newReportType);
        setSelectedCustomerId(''); // Reset customer selection

        // Fetch customers again when the report type changes
        if (agentId) {
            fetchCustomers(agentId, newReportType)
                .then(data => setCustomers(data))
                .catch(error => console.error("Error fetching customers:", error));
        }
    };

    const handleCustomerChange = (e) => {
        const selectedId = e.target.value;
        setSelectedCustomerId(selectedId);

        const selectedCustomer = customers.find(cust => cust.id.toString() === selectedId);
        console.log("Selected Customer:", selectedCustomer);

        if (selectedCustomer) {
            const dbLang = selectedCustomer.form_language?.toLowerCase();
            const uiLang = dbLang === 'hi' ? 'hi' : 'en';
            const javaLang = dbLang === 'hi' ? 'hindi' : 'english';

            setFormLanguage(uiLang);
            setLanguage(javaLang);

            console.log("Resolved UI lang:", uiLang);
            console.log("Resolved Java/backend lang (used in API):", javaLang);
            console.log("Selected Customer form language:", selectedCustomer.form_language);
        } else {
            // fallback (optional)
            setFormLanguage('en');
            setLanguage('english');
        }

        console.log("Selected Customer ID changed to:", selectedId);
    };


    const handleLanguageChange = (e) => {
        setLanguage(e.target.value);
    };

    const handleFundTypeChange = (e) => {
        setFundType(e.target.value);
    };

    const handleFileDownload = async () => {
        if (!agentId) {
            alert('Agent ID not found. Pls Login Again');
            return;
        }
        if (!reportType) {
            alert('Please select a Report Type.');
            return;
        }
        if (!selectedCustomerId) {
            alert('Please select a Customer.');
            return;
        }

        const formData = new FormData();
        formData.append('agentId', agentId);
        formData.append('reportType', reportType);
        formData.append('customer', selectedCustomerId);

        const selectedCustomer = customers.find(cust => cust.id.toString() === selectedCustomerId);

        if (!selectedCustomer) {
            alert('Selected customer not found. Please select a valid customer.');
            return;
        }

        formData.append('customerName', selectedCustomer.name);

        // Hardcode language if reportType is not 'Financial Horoscope'
        if (reportType !== 'Financial Horoscope') {
            formData.append('language', 'english');
        } else {
            formData.append('language', language);
        }

        // Hardcode fundType if reportType is not 'Financial Horoscope'
        if (reportType !== 'Financial Horoscope') {
            formData.append('fundType', 'mutual');
        } else {
            formData.append('fundType', fundType);
        }

        console.log("handleFileDownload - reportType being sent:", reportType);

        try {
            setLoading(true);
            setDownloadProgress(0);

            const response = await downloaddbPdf(formData, (progressEvent) => {
                if (progressEvent.total) {
                    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    setDownloadProgress(progress);
                }
            });

            if (response.status !== 200) {
                throw new Error("Failed to generate PDF.");
            }

            const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];
            let filename = "report.pdf";
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) {
                    filename = match[1];
                }
            }

            const blob = new Blob([response.data], { type: "application/pdf" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);

            setDownloadProgress(100);
        } catch (error) {
            console.error("Error downloading PDF:", error);
            alert("Failed to generate the PDF. Please try again.");
        } finally {
            setTimeout(() => {
                setLoading(false);
                setDownloadProgress(0);
            }, 1000);
        }
    };

    return (
        <div className="file-download-container">
            <div className="language-selection">
                <label style={{ color: 'rgb(112, 16, 99)' }}>Report Type:</label>
                <select value={reportType} onChange={handleReportTypeChange}>
                    {reportTypeOptions.map((option) => (
                        <option key={option} value={option}>{option || 'Select Report Type'}</option>
                    ))}
                </select>
            </div>

            {reportType && (
                <>
                    <div className="language-selection">
                        <label style={{ color: 'rgb(112, 16, 99)' }}>Select Customer:</label>

                      {/* Search input with icon */}
                      <div className="search-container">
                            <div className="search-icon">🔍</div>
                            <input
                                type="text"
                                placeholder="Search customers..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="search-input"
                            />
                        </div>
                        <select value={selectedCustomerId} onChange={handleCustomerChange} >
                            <option value="">Select a customer</option>
                            {filteredCustomers.map(cust => (
                                <option key={cust.id} value={cust.id.toString()}>{cust.name}</option>
                            ))}
                        </select>

                    </div>

                    {selectedCustomerId && (
                        <>
                            {reportType === 'Financial Horoscope' && (
                                <>
                                    <div className="language-selection">
                                        <label style={{ color: 'rgb(112, 16, 99)' }}>Report Language:</label>
                                        <select
                                            style={{ minWidth: '160px' }}
                                            value={language}
                                            onChange={handleLanguageChange}
                                            disabled={formLanguage === 'hi' || !selectedCustomerId}
                                        >
                                            <option value="english" disabled={formLanguage === 'hi'}>English</option>
                                            <option value="hindi">Hindi</option>
                                        </select>
                                        {formLanguage === 'hi' && (
                                            <p style={{ fontSize: '12px', color: 'red', margin: '4px 0 0' }}>
                                                This customer filled the form in Hindi. Language cannot be changed.
                                            </p>
                                        )}
                                    </div>

                                    <div className="language-selection">
                                        <label>Fund Type:</label>
                                        <label style={{ color: 'rgb(112, 16, 99)' }}>Fund Type:</label>

                                        <select value={fundType} onChange={handleFundTypeChange} disabled={!selectedCustomerId}>
                                            <option value="mutual">Mutual</option>
                                            <option value="non-mutual">Non-Mutual</option>
                                        </select>
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </>
            )}

            <button onClick={handleFileDownload} disabled={loading || !reportType || !selectedCustomerId}>
                {loading ? 'Generating...' : 'Download PDF'}
            </button>

            {loading && (
                <div className="progress-bar">
                    <div className="progress" style={{ width: `${downloadProgress}%` }}>
                        {downloadProgress}%
                    </div>
                </div>
            )}
        </div>
    );
}

export default FileDownload;